module.exports = __webpack_public_path__ + "img/login-bg.2aadfb3a.png";